import { render } from "./CompanyServices.vue?vue&type=template&id=7d2ef375"
import script from "./CompanyServices.vue?vue&type=script&lang=js"
export * from "./CompanyServices.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__